import { Button } from '@chakra-ui/react';
import CardMy from 'components/CardMy';
import Loader from 'components/Loader';
import ActionCell from 'components/Table/Cells/ActionCell';
import TeamCardHeader from 'components/TeamCardHeader';
import DeleteTeamDialog from 'pages/Team/DeleteTeamDialog';
import EditTeamNameDialog from 'pages/Team/EditTeamNameDialog';
import InviteMemberDialog from 'pages/Team/InviteMemberDialog';
import { useEffect } from 'react';
import { FiPlus } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { ROUTES } from 'routes';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchSingleTeamAgents, selectSingleTeamsAgents, selectSingleTeamsAgentsIsLoading } from 'store/slices/teams';
import SingleTeamTable from '../SingleTeam/SingleTeamTable';

const SingleTeam = () => {
    const { slug } = useParams();
    const { team } = useAppSelector(selectSingleTeamsAgents);
    // const navigate = useNavigate();
    const dispatch = useAppDispatch();
    // const singleTeamsIsLoading = useAppSelector(selectSingleTeamsIsLoading);
    const singleTeamsAgentsIsLoading = useAppSelector(selectSingleTeamsAgentsIsLoading);

    useEffect(() => {
        // dispatch(fetchSingleTeam({ id: slug }))
        //     .unwrap()
        //     .catch(error => {
        //         console.log('error = ', error);
        //         navigate(ROUTES.team.fullPath);
        //     });
        dispatch(fetchSingleTeamAgents({ id: slug }))
            .unwrap()
            .catch(error => {
                // console.log('error = ', error);
                // navigate(ROUTES.team.fullPath);
            });
    }, []);

    return (
        <CardMy>
            {singleTeamsAgentsIsLoading ? (
                <Loader />
            ) : (
                <>
                    <TeamCardHeader
                        backHref={ROUTES.team.fullPath}
                        teamName={team?.title}
                        button={
                            <InviteMemberDialog
                                trigger={
                                    <Button
                                        variant="brand"
                                        leftIcon={<FiPlus />}
                                        height="40px"
                                        padding="0 16px"
                                        fontSize="14px"
                                        marginLeft="8px"
                                    >
                                        Invite member
                                    </Button>
                                }
                                teamId={team?.id}
                                companyId={team?.companyId}
                                title={team?.title}
                            />
                        }
                        actions={
                            <ActionCell>
                                <EditTeamNameDialog title={team?.title} id={slug} />
                                <DeleteTeamDialog title={team?.title} id={slug} />
                            </ActionCell>
                        }
                    />
                    <SingleTeamTable />
                </>
            )}
        </CardMy>
    );
};

export default SingleTeam;
